'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eruntime$002e$002dAbstract$002dPartial$002dFunction from "./scala.runtime.-Abstract-Partial-Function.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_DomApi$$anon$2(outer) {
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
}
export { $c_Lcom_raquo_laminar_DomApi$$anon$2 as $c_Lcom_raquo_laminar_DomApi$$anon$2 };
$p = $c_Lcom_raquo_laminar_DomApi$$anon$2.prototype = new $j_scala$002eruntime$002e$002dAbstract$002dPartial$002dFunction.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_raquo_laminar_DomApi$$anon$2;
/** @constructor */
function $h_Lcom_raquo_laminar_DomApi$$anon$2() {
}
export { $h_Lcom_raquo_laminar_DomApi$$anon$2 as $h_Lcom_raquo_laminar_DomApi$$anon$2 };
$h_Lcom_raquo_laminar_DomApi$$anon$2.prototype = $p;
$p.de = (function(x) {
  return (((typeof x) === "string") || false);
});
$p.cr = (function(x, default$1) {
  return (((typeof x) === "string") ? x : default$1.j(x));
});
var $d_Lcom_raquo_laminar_DomApi$$anon$2 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_DomApi$$anon$2, "com.raquo.laminar.DomApi$$anon$2", ({
  hu: 1,
  aO: 1,
  o: 1,
  t: 1,
  a: 1
}));
export { $d_Lcom_raquo_laminar_DomApi$$anon$2 as $d_Lcom_raquo_laminar_DomApi$$anon$2 };
